import { render, staticRenderFns } from "./StudentTypePanelFeeContent.vue?vue&type=template&id=fa9604e2"
import script from "./StudentTypePanelFeeContent.vue?vue&type=script&lang=js"
export * from "./StudentTypePanelFeeContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports